.disableAnimations * {
  transition: none !important;
}
